import PostHog from 'posthog-js';

export default {
  install(Vue, { auth, store } = {}) {
    // Validate environment variables
    if (!process.env.VUE_APP_POSTHOG_KEY) {
      console.warn('PostHog API key missing');
      Vue.prototype.$posthog = {
        capture: () => {},
        identify: () => {},
        reset: () => {},
      };
      return;
    }

    // Initialize PostHog
      const posthog = PostHog.init(process.env.VUE_APP_POSTHOG_KEY, {
        api_host: process.env.VUE_APP_POSTHOG_HOST,
        autocapture: true,
        capture_pageview: false,
        enable_recording: true,
        person_profiles: 'identified_only',
        mask_all_inputs: true,
        mask_input_options: {
          password: true,
          email: true,
          text: false,
        },
      });

      // Attach PostHog to Vue prototype and global window
      Vue.prototype.$posthog = posthog;
      window.posthog = posthog;

      // Identify user when authenticated
      auth?.onAuthStateChanged?.(async (user) => {
        if (!store) {
          console.warn('Vuex store not provided to PostHog plugin');
          return;
        }
        if (user) {
          await store.dispatch('login', user);
          const role = store.state.currentRole || 'unknown';
          if (role === 'unknown' && user?.uid) {
            try{
              await store.dispatch('fetchUserProfile', user);
            } catch (error) {
              console.error('Error fetching roleAssociated for login:', error);
            }
          }
          posthog.identify(user.uid, {
            email: user.email,
            role: role,
          });
        } else {
          await store.dispatch('resetUser');
          posthog.reset();
        }
      });
  }
};